import { Select, Card, MUTED_TEXT, Spinner, stackStyle } from "@dayvise/react-ui";
import { useHome, useHomeMutation } from "./hooks.ts";

/**
 * Default workspace per authenticated identity and scope (HOME-01..05).
 *
 * The server validates membership on both read and write, resolves the
 * scope-specific default on entry, silently drops a default whose membership
 * was revoked (reported as stale), and never touches an explicit current
 * workspace choice. Nothing here is a messaging destination.
 */
export function DefaultWorkspaceCard() {
  const home = useHome();
  const mutation = useHomeMutation();
  const resolution = home.data;
  const error = home.error ?? mutation.error;
  const selected = resolution?.storedWorkspaceId ?? "";

  return (
    <Card
      title="Default workspace"
      subtitle="Where Dayvise lands for this account and scope. Saved per identity, membership is re-validated on every read, and a revoked workspace is dropped rather than followed."
    >
      <div style={stackStyle("var(--dayvise-space-sm)")}>
        {home.isPending || resolution === undefined ? <Spinner label="Loading default workspace" /> : null}
        {error ? <p role="alert" style={{ color: "var(--dayvise-color-danger)" }}>{error instanceof Error ? error.message : "Could not read the default workspace"}</p> : null}
        {resolution !== undefined ? (
          <Select
            label="Default workspace for this scope"
            value={selected}
            options={[
              { value: "", label: "Ask on entry (no default)" },
              ...resolution.workspaces.map((workspace) => ({ value: workspace.workspaceId, label: `${workspace.name} (${workspace.kind})` })),
            ]}
            disabled={mutation.isPending}
            onChange={(event) => mutation.mutate(event.target.value === "" ? null : event.target.value)}
          />
        ) : null}
        {resolution?.stale ? (
          <p style={{ ...MUTED_TEXT, margin: 0 }}>The previously saved default no longer accepts this identity; it was cleared.</p>
        ) : null}
        {mutation.data ? <p style={{ ...MUTED_TEXT, margin: 0 }}>Default workspace saved.</p> : null}
      </div>
    </Card>
  );
}
